
import { primary1_30, primary2 } from '@shane-collective/design-system';
import { YStack, Text } from 'tamagui'; 
import NotFoundIllustration from '../../images/illustrations/not-found.png'
import { Link } from 'react-router-dom';

function NotFoundPage() {

  return (
    <YStack
      height="100%"
      justifyContent="center"
      alignItems="center"
      backgroundColor={primary1_30}
      padding="$4"
    >
      <YStack
        justifyContent="center"
        alignItems="center"
        maxWidth={500}
        backgroundColor={primary1_30}
        borderRadius="$6"
        padding="$6"
      >
        <YStack>
            <img src={NotFoundIllustration} height="400px" alt="Page not found"/>
        </YStack>
        <Text
          fontSize={32}
          fontWeight="bold"
          color={primary2}
          marginBottom="$4"
          fontFamily= "$rethinkSans"
        >
          Page Not Found
        </Text>
        <Text
          fontSize={18}
          color={primary2}
          marginBottom="$6"
          textAlign="center"
          fontFamily= "$rethinkSans"

        >
          Try going back <Link to="/">home</Link>
        </Text>
       
      </YStack>
    </YStack>
  );
}

export default NotFoundPage;
